import { cn } from '@/lib/utils'

/* Skeleton (design board 12): surface-muted blocks, radius 8, a slow 1.4s
   pulse that stops under prefers-reduced-motion (see globals.css). */
function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('bg-surface-muted animate-pulse rounded-sm', className)}
      {...props}
    />
  )
}

export { Skeleton }
